import { InjectionToken } from '@angular/core';

import { AuthenticationService } from '../authentication.service';

/**
 * Service to add add an options object to the WebSocket connection
 *
 * @export
 */

export class WebSocketOptionsService {
    /**
     * @property token - string that holds JWT token obtained by AuthenticationService
     */
    private token: string;

    /**
     * @param authenticationService - AuthenticationService is the dependency that allows us to add an authorization header with JWT token provided by this service
     */
    constructor(private authenticationService: AuthenticationService, public options: any) {}

    /**
     * Set http authorization headers
     */
    async setAuthorizationOptions(): Promise<void> {
        await this.fetchToken();

        if (this.token !== null) {
            /** add JWT Token to Authorization Option */

            const authOption = {
                transportOptions: {
                    polling: {
                        extraHeaders: {
                            Authorization: `Bearer ${this.token}`,
                        },
                    },
                },
                forceNew: true,
            };

            this.options = { ...this.options, ...authOption };
        }
    }

    /**
     * Fetch token from current authentication services's user
     */
    async fetchToken(): Promise<void> {
        this.token = await this.authenticationService.user.getSessionToken();
    }
}

export const WEBSOCKET_SERVICE_CONNECTION_OPTIONS = new InjectionToken<any>('websocket connection options object');

/**
 * Factory to provide the [HttpRequestHeadersService]{@link HttpRequestHeadersService}
 * @param authenticationService - AuthenticationService is the dependency that allows us to add an authorization header with JWT token provided by this service.
 * We can inject it using this factory
 */

export function PROVIDE_WEBSOCKET_OPTIONS_SERVICE_FACTORY(
    authenticationService: AuthenticationService,
    webSocketOptions: any
): WebSocketOptionsService {
    return new WebSocketOptionsService(authenticationService, webSocketOptions);
}
